import { Loader2 } from "lucide-react";
import { useTranslations } from "use-intl";

/**
 * Design spec AC7 — shared across every "match to transaction" modal (payables, receivables,
 * receipts): a distinct "still checking" state; the acknowledgment checkbox must never render
 * before this fetch resolves.
 */
export default function StillCheckingState() {
  const t = useTranslations("consultantMatching.shared");
  return (
    <div className="flex items-center justify-center py-8">
      <Loader2 className="h-6 w-6 animate-spin mr-2" />
      <span>{t("stillChecking")}</span>
    </div>
  );
}
